export const REASONS_ORDER = [
    'animal_welfare',
    'bullying_harassment',
    'bullying_harassment_women',
    'clips_copyright',
    'coordinated_harm',
    'copyright',
    'csam',
    'csam_deepfake',
    'csam_jokes',
    'disasters_tragedies',
    'discrimination',
    'eating_disorder',
    'epilepsy',
    'graphic_medical_content',
    'hate',
    'illegal_activity',
    'illegal_substances',
    'incitement_violence_women',
    'incitement_violence_hate',
    'private_information',
    'misinformation',
    'mutilation',
    'nonconsensual_deepfake',
    'nonconsensual_image',
    'nudity',
    'perpetrators',
    'pornography',
    'public_health',
    'real_gore',
    'school_shootings',
    'sexual_violence',
    'solicitation',
    'spam',
    'self_harm',
    'terrorism',
    'threatening_stalking',
    'threatening_stalking_women',
    'trademark',
    'underage_user',
    'violence',
]

export const REASONS_DESCRIPTION = {
    animal_welfare: 'Animal welfare',
    bullying_harassment: 'Bullying and harassment',
    bullying_harassment_women: 'Bullying and harassment of women',
    clips_copyright: 'Clips Copyright',
    coordinated_harm: 'Coordinated harm or threat to life',
    copyright: 'Copyright infringement',
    csam: 'CSAM',
    csam_deepfake: 'CSAM deepfake',
    csam_jokes: 'CSAM jokes or mockery',
    disasters_tragedies: 'Disasters and tragedies',
    discrimination: 'Discrimination',
    eating_disorder: 'Eating disorder',
    epilepsy: 'Epilepsy',
    graphic_medical_content: 'Graphic medical content',
    hate: 'Hate',
    illegal_activity: 'Illegal content: Illegal activity',
    illegal_substances: 'Illegal content: Selling illegal substances/service',
    incitement_violence_women: 'Incitement to violence against women',
    incitement_violence_hate: 'Incitement to violence or hate',
    private_information: 'Private information',
    misinformation: 'Misinformation',
    mutilation: 'Mutilation',
    nonconsensual_deepfake: 'Non-consensual deepfake',
    nonconsensual_image: 'Non-consensual image',
    nudity: 'Nudity',
    perpetrators: 'Perpetrators of violence',
    pornography: 'Pornography',
    public_health: 'Public health',
    real_gore: 'Real gore',
    school_shootings: 'School shootings',
    sexual_violence: 'Sexual violence',
    solicitation: 'Solicitation',
    spam: 'Spam',
    self_harm: 'Suicide',
    terrorism: 'Terrorism and violent extremists',
    threatening_stalking: 'Threatening or stalking',
    threatening_stalking_women: 'Threatening or stalking of women',
    trademark: 'Trademark violation',
    underage_user: 'Underage user',
    violence: 'Violence',
}
